import { engineComponent, ArrayUtils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { BaseElement, BaseElementAttributes } from "../Components/Elements/Graphics/BaseElement";
import ReflectionFilter = PIXI.filters.ReflectionFilter;
import DisplayObject = PIXI.DisplayObject;

@engineComponent(ComponentTypes.DisplayObject)
export class ReflectionElement extends BaseElement {
    private boundary: number;

    private amplitude: Array<number>;

    private reflectionAlpha: Array<number>;

    public childs: Object = {};

    public createByNode(node: Element): void {
        if (DEBUG) {
            if (
                node.hasAttribute(BaseElementAttributes.DEBUG) &&
                node.getAttribute(BaseElementAttributes.DEBUG) === "true"
            ) {
                debugger;
            }
        }

        this.boundary = 0.5;
        this.amplitude = [0, 0];
        this.reflectionAlpha = [1, 1];

        if (node.hasAttribute(ReflectionElementAttributes.BOUNDARY)) {
            this.boundary = parseFloat(node.getAttribute(ReflectionElementAttributes.BOUNDARY));
        }

        if (node.hasAttribute(ReflectionElementAttributes.AMPLITUDE)) {
            this.amplitude = ArrayUtils.numberArray(node.getAttribute(ReflectionElementAttributes.AMPLITUDE));
        }

        if (node.hasAttribute(ReflectionElementAttributes.REFLECTION_ALPHA)) {
            this.reflectionAlpha = ArrayUtils.numberArray(
                node.getAttribute(ReflectionElementAttributes.REFLECTION_ALPHA),
            );
        }
    }

    public addElement(element: BaseElement): void {
        this.childs[element.name] = element;
        this.addChild(element);
    }

    public activateFilter(): void {
        let reflection = new ReflectionFilter({
            boundary: this.boundary,
            amplitude: this.amplitude,
            alpha: this.reflectionAlpha,
        });

        reflection.blendMode = 3;

        this.filters = [reflection];
    }
}

export const ReflectionElementAttributes = {
    DEBUG: "Debug",

    BOUNDARY: "Boundary",
    AMPLITUDE: "Amplitude",
    REFLECTION_ALPHA: "ReflectionAlpha",

    ELEMENTS: "Elements",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/ReflectionElement.ts
 **/